import { useNavigate } from "react-router-dom";
import Reveal from "./Reveal";
import { IconArrow } from "./icons";

export default function CTABanner({ headline, sub, btnText, to = "/quote" }) {
  const navigate = useNavigate();
  return (
    <section className="sb-noise" style={{
      position: "relative", overflow: "hidden",
      background: "linear-gradient(135deg, var(--plum) 0%, var(--plum-mid) 50%, #3D2040 100%)",
      padding: "clamp(48px, 8vw, 80px) 0", textAlign: "center",
    }}>
      <div style={{
        position: "absolute", top: "-50%", left: "-20%", width: "60%", height: "200%",
        background: "radial-gradient(circle, rgba(212,168,83,0.08) 0%, transparent 70%)",
        pointerEvents: "none",
      }} />
      <div style={{
        position: "absolute", bottom: "-50%", right: "-20%", width: "60%", height: "200%",
        background: "radial-gradient(circle, rgba(199,125,138,0.06) 0%, transparent 70%)",
        pointerEvents: "none",
      }} />
      <div className="sb-container" style={{ position: "relative", zIndex: 2 }}>
        <Reveal>
          <h2 style={{ color: "var(--white)", marginBottom: "14px" }}>
            {headline || "Ready to Shake Things Up?"}
          </h2>
          <p style={{ color: "rgba(255,255,255,0.7)", maxWidth: "520px", margin: "0 auto 28px", fontSize: "1.05rem" }}>
            {sub || "Whether it's a hen party, birthday bash, or corporate event — let's create a cocktail experience your guests will never forget."}
          </p>
          <button className="sb-btn sb-btn-primary" onClick={() => { navigate(to); window.scrollTo({ top: 0 }); }}>
            {btnText || "Enquire Now"} <IconArrow />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
